import { ChainId } from './chainId'

export const FORMATIC_MAINNET_API_KEY = 'pk_live_7482D0ABC630240A'
export const FORTMATIC_TEST_API_KEY = 'pk_test_8DDB372956C42895'

export const PORTIS_DAPP_ID = 'e94e6c93-a02b-428f-9f38-9d7ebeeabc8f'

export const INFURA_URLS = {
  [ChainId.Mainnet]: `https://mainnet.infura.io/v3/9c59a8863e4d439696451d5e026d6098`,
  [ChainId.Kovan]: `https://kovan.infura.io/v3/22ad81072a2a4c26b7116af96130fb33`,
}
